import { baseApi } from 'core/api';
import { useToastStore } from 'store/modules';

const state = () => ({
    _settings: [],
    _settingsLoading: false,
    _settingsLoadingError: false,
    _settingsList: [],
    _settingsListLoading: false,
    _settingsListLoadingError: false,
    _settingsUpdating: false,
});

const getters = {
    hubspotSettings: (state) => state._settings,
    hubspotSettingsLoading: (state) => state._settingsLoading,
    hubspotSettingsLoadingError: (state) => state._settingsLoadingError,
    hubspotAvailableSettingsList: (state) => state._settingsList,
    hubspotAvailableSettingsListLoading: (state) => state._settingsListLoading,
    hubspotAvailableSettingsListLoadingError: (state) => state._settingsListLoadingError,
    hubspotSettingsUpdating: (state) => state._settingsUpdating,
};

const actions = {
    async getHubspotAvailableSettingsList() {
        if (this._settingsListLoading) return;

        this._setHubspotSettingsListLoad();

        return baseApi
            .get('/integration/settings/hubspot/list')
            .then((response) => {
                this._setHubspotSettingsListLoaded({
                    settings: response.data,
                });

                return response;
            })
            .catch((error) => {
                const message = error.response?.data?.message || 'Failed to load settings';

                this._setHubspotSettingsListLoadError(message);

                useToastStore().showToast({
                    type: 'danger',
                    message: message,
                });

                return error;
            });
    },

    async getHubspotSettingsList() {
        if (this._settingsLoading) return;

        this._setHubspotSettingsLoad();

        return baseApi
            .get('/integration/settings/hubspot')
            .then((response) => {
                this._setHubspotSettingsLoaded({
                    settings: response.data.data,
                });

                return response.data.data;
            })
            .catch((error) => {
                const message = error.response?.data?.message || 'Failed to load settings';

                this._setHubspotSettingsLoadError(message);

                useToastStore().showToast({
                    type: 'danger',
                    message: message,
                });

                return error;
            });
    },

    updateHubspotSettings(params) {
        this._setHubspotSettingsUpdating(true);
        return baseApi
            .put('/integration/settings/hubspot', params)
            .then((response) => {
                this._setHubspotSettingsUpdated(response.data.data);

                useToastStore().showToast({
                    type: 'success',
                    message: 'Settings saved.',
                });

                return response;
            })
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: 'Error saving settings.',
                });

                return error;
            })
            .finally(() => {
                this._setHubspotSettingsUpdating(false);
            });
    },
    updateHubspotSettingsList(params) {
        this._setHubspotSettingsUpdating(true);
        return baseApi
            .put('/integration/settings/hubspot/list', { data: params })
            .then((response) => {
                this._setHubspotSettingsUpdated(response.data.data);

                useToastStore().showToast({
                    type: 'success',
                    message: 'Settings saved.',
                });

                return response;
            })
            .catch((error) => {
                useToastStore().showToast({
                    type: 'danger',
                    message: 'Error saving settings.',
                });

                return error;
            })
            .finally(() => {
                this._setHubspotSettingsUpdating(false);
            });
    },

    // Private methods
    _setHubspotSettingsLoad() {
        this._settingsLoading = true;
        this._settingsLoadingError = null;
    },

    _setHubspotSettingsLoadError(message) {
        this._settingsLoading = false;
        this._settingsLoadingError = message;
        this._settings = [];
    },

    _setHubspotSettingsLoaded({ settings }) {
        this._settingsLoading = false;
        this._settingsLoadingError = null;
        this._settings = settings;
    },

    _setHubspotSettingsUpdated(data) {
        this._settings = data;
    },

    _setHubspotSettingsUpdating(status) {
        this._settingsUpdating = status;
    },

    _setHubspotSettingsListLoad() {
        this._settingsListLoading = true;
        this._settingsListLoadingError = null;
    },

    _setHubspotSettingsListLoadError(message) {
        this._settingsListLoading = false;
        this._settingsListLoadingError = message;
        this._settingsList = [];
    },

    _setHubspotSettingsListLoaded({ settings }) {
        this._settingsListLoading = false;
        this._settingsListLoadingError = null;
        this._settingsList = settings;
    },
};

export default {
    state,
    getters,
    actions,
};
